module.exports = __webpack_public_path__ + "img/main.3aab2124.png";